// Re-export types and constants from fe-common (single source of truth)
export type {
  CurrencyCode,
  CurrencyFormatConfig,
  CurrencyFormatName,
  CurrencyFormatOptions,
  CurrencyFormatOverrides,
  CurrencyOverrideConfig,
  FormatPriceOptions,
  FormattedPriceResult,
  PriceInput,
  RegionDetailsLike,
  ToBCP47LocaleOptions,
  UseFormattedPriceOptions,
} from '@lastbrand/fe-common'
export {
  BASE_CURRENCY_FORMATS,
  CURRENCY_FORMAT_OVERRIDES,
  DEFAULT_CURRENCY,
  DEFAULT_CURRENCY_FORMAT,
  DEFAULT_LOCALE,
  toBCP47Locale,
} from '@lastbrand/fe-common'

// Hooks and utility functions
export {
  formatPrice,
  stripTrailingZeroDecimals,
  useCurrencyDisplay,
  useFormatPrice,
  useFormattedPrice,
} from './currency.hook'

// Component
export { default, FormattedPrice, type FormattedPriceProps } from './currency.component'
